<script setup>
import { defineProps, defineEmits, computed} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "controlesDesativados",
]);

const emits = defineEmits([
    "update:alteraDado",
]);

//==================================================================//
//========================= Altera Dado ============================//
//==================================================================//

const alteraDado = (update) => {

    emits('update:alteraDado',update);

};

//==================================================================//
//=================== Desativa Observações =========================//
//==================================================================//

const desativaObservacoes = computed(()=>{

    if(props?.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//================== Ao Preencher Observação =======================//
//==================================================================//

const aoPreencherObservacao = (observacao) => {

    alteraDado({
        observacao: observacao
    });
    
};

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">

                Observações

            </h3>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <v-textarea
                    label="Observações"
                    :value="props?.dado?.observacao"
                    :disabled="desativaObservacoes"
                    variant="outlined"
                    no-resize
                    outlined
                    auto-grow
                    @input="aoPreencherObservacao"
                ></v-textarea>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-titulo {
    grid-area: titulo;
}

</style>